module.exports = __webpack_public_path__ + "static/media/results.6091d5f1.jpg";